const TransferHeaderTabs = ({
  active,
  onChange,
  isNewUser,
  totalBalanceUsd,
}) => {
  const isWithdrawDisabled = isNewUser || Number(totalBalanceUsd || 0) <= 0;

  return (
    <div className="relative flex h-12 w-[192px] shrink-0 items-center justify-between rounded-[28px] border border-[#c4c4c4]/50 bg-background-alt p-1 font-outfit shadow-[inset_0_2px_8px_rgba(0,0,0,0.08)] dark:bg-primary-600">
      <button
        type="button"
        onClick={() => onChange("Deposit")}
        className={`flex items-center justify-center rounded-[24px] px-3 text-sm font-medium leading-[19.5px] custom-transition ${
          active === "Deposit"
            ? "h-10 w-[91px] bg-[#333] text-white shadow-[2px_2px_4px_rgba(0,0,0,0.12)]"
            : "h-[38px] w-[91px] text-text-secondary dark:text-black"
        }`}
      >
        Deposit
      </button>

      <button
        type="button"
        disabled={isWithdrawDisabled}
        onClick={() => onChange("Withdraw")}
        className={`flex items-center justify-center rounded-[24px] px-3 text-sm font-medium leading-[19.5px] custom-transition ${
          active === "Withdraw" && !isWithdrawDisabled
            ? "h-10 w-[93px] bg-[#333] text-white shadow-[2px_2px_4px_rgba(0,0,0,0.12)]"
            : "h-[38px] w-[93px] text-text-secondary dark:text-black"
        } disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none`}
      >
        Withdraw
      </button>
    </div>
  );
};

export default TransferHeaderTabs;
